import { useState, useEffect } from "react";
import { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import TableCard from "../tableCard/TableCard.jsx";
import useAxios from "../../services/useAxios.tsx";
export default function MessageInfo({ user_id, content }) {
  // useEffect(() => {
  //   let x;
  //   if (user_id != undefined) {
  //     x = { user_id: user_id };
  //   }
  //   messageListApi(x).then(data => {
  //     // setMessageList(data.data);
  //     // });
  //     // let temp = [...messageList];
  //     if (user_id == undefined) {
  //       let temp = [...data.data];
  //       let temp2 = [];
  //       for (let i = 0; i < temp.length; i++) {
  //         let object = {};
  //         object.sender = temp[i].sender[0].fullname;
  //         object.receiver = temp[i].reciver[0].fullname;
  //         object.auto = temp[i].automate;
  //         object.type = temp[i].type;
  //         object.date = temp[i].mtm;
  //         object.text = temp[i].text;
  //         temp2.push(object);
  //       }

  //       setContent(temp2);
  //     } else {
  //       // let temp =
  //     }
  //   });
  // }, []);
  const [header, setHeader] = useState([
    { type: "title", title: "فرستنده", name: "sender" },
    {
      type: "title",
      title: "گیرنده",
      name: "receiver"
    },
    { type: "title", title: "تاریخ", name: "date" },
    { type: "description", title: "متن", name: "text" },
    { type: "title", title: "نوع ارتباط", name: "type" },
    { type: "title", title: "نوع پیام", name: "auto" }
  ]);
  // const [content, setContent] = useState([
  // {
  // sender: "",
  // receiver: "",
  // text: ""
  // date: "",
  // type: ""
  // auto: ""
  // }
  // ]);
  const convertTimestampToDate = timeStamp => {
    const date = new DateObject({
      date: timeStamp * 1000,
      calendar: persian
    });
    let showDate;
    timeStamp != "" ? (showDate = date.format()) : (showDate = "-");
    return showDate;
  };

  return (
    <>
      {content.length > 0 ? (
        content?.map(value => {
          return (
            <TableCard
              column={header}
              content={{
                ...value,
                date: convertTimestampToDate(value.date),
                auto: value.auto != "0" ? "سیستمی" : "توسط اپراتور",
                type: value.type == "1" ? "تماس" : "پیام",
                sender: value.sender,
                receiver: value.receiver,
                text: value.text
              }}
              bg={"warning_custom"}
              widthParent={"80%"}
            ></TableCard>
          );
        })
      ) : (
        <div>هیچ پیامی وجود ندارد.</div>
      )}
    </>
  );
}
